import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import toast from "utils/toast";
import { DateRangePicker } from "rsuite";
import { afterToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import reportsLineChartData from "../../dashboard/data/reportsLineChartData";
import Papa from 'papaparse';

function TransactionSummary() {
  const { transactionSummarycolumns } = data();
  const { predefinedRanges } = reportsLineChartData;
  const [auditTrails, setAuditTrails] = useState([]);

  // Function to get today's date at midnight in AEST timezone
  const getTodayDateAtMidnight = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Set to start of the day in local time
    return new Date(now.getTime() - now.getTimezoneOffset() * 60000); // Convert to local midnight in AEST
  };

  // Initialize lastMonthDateRange to today's date at local midnight
  const [lastMonthDateRange, setLastMonthDateRange] = useState([
    getTodayDateAtMidnight().toISOString().slice(0, 10),
    getTodayDateAtMidnight().toISOString().slice(0, 10)
  ]);

  const api = useApi();

  // Format date to 'yyyy-MM-dd' and adjust to AEST timezone
  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      console.error("Invalid date provided:", date);
      return '';
    }
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().slice(0, 10);
  };

  const getTransactionSummary = (dateRange) => {
    if (!dateRange || dateRange.length !== 2) return;

    const fromDate = new Date(dateRange[0]);
    const toDate = new Date(dateRange[1]);

    const data = {
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
    };

    api.post("reports/gettransactionsummary", data)
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          setAuditTrails(response.data.body);
        } else {
          setAuditTrails([]);
          const toastId = toast.error("No Record Found", { autoClose: false });
          setTimeout(() => toast.dismiss(toastId), 1000);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        setAuditTrails([]);
        const toastId = toast.error("No Record Found", { autoClose: false });
        setTimeout(() => toast.dismiss(toastId), 1000);
      });
  };

  const generateCSV = () => {
    if (auditTrails.length === 0) {
      return '';
    }

    const headers = transactionSummarycolumns.map(column => column.Header);

    const transactionsWithUppercaseColumns = auditTrails.map(trail => {
      return transactionSummarycolumns.map(column => {
        const accessor = column.accessor;
        const value = typeof accessor === 'function' ? accessor(trail) : trail[accessor];
        return value;
      });
    });

    const csvData = [headers, ...transactionsWithUppercaseColumns];

    const csv = Papa.unparse(csvData, {
      quotes: true,
    });

    return csv;
  };

  const handleDownloadCSV = () => {
    if (auditTrails.length === 0) {
      const toastId = toast.error("No records found to download", { autoClose: false });
      setTimeout(() => toast.dismiss(toastId), 1000);
      return;
    }

    const csvData = generateCSV();

    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;

    const fileName = `Transaction_Summary_${dateTimeString}.csv`;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    getTransactionSummary(lastMonthDateRange);
  }, [lastMonthDateRange]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3} display="flex" alignItems="center">
                <MDBox flex={1} />
                <DateRangePicker
                  disabledDate={afterToday()}
                  ranges={predefinedRanges}
                  onChange={(dateRange) => {
                    if (dateRange && dateRange.length === 2) {
                      setLastMonthDateRange(dateRange);
                      getTransactionSummary(dateRange);
                    }
                  }}
                  format="dd MMMM yyyy"
                  value={lastMonthDateRange.length ? [new Date(lastMonthDateRange[0]), new Date(lastMonthDateRange[1])] : []}
                />
                <MDBox flex={1} display="flex" justifyContent="flex-end">
                  <MDButton
                    variant="gradient"
                    onClick={handleDownloadCSV}
                    color="info"
                  >
                    Export
                  </MDButton>
                </MDBox>
              </MDBox>
            </Grid>
            <DataTable
              table={{ columns: transactionSummarycolumns, rows: auditTrails }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              hideExpandColumn= {true}
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TransactionSummary;
